import { useReactiveVar } from "@apollo/client";
import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "src/hooks/useQueryParams";
import { SharedState } from "src/services/sharedState";
import { logout } from "src/services/url";
import { AccessDenied } from "../Feedback/AccessDenied";
import { Loading } from "../Feedback/Loading";
import { getAuthContext } from "../Providers/state/localStorage";
import { useIsParentStorage } from "./useIsParentStorage";

/*
    The purpose of this component is to handle any authorization postprocessing after authorization has been completed by auth 0.
*/
export function AuthCallback() {
  const navigate = useNavigate();
  const url = useReactiveVar(SharedState.redirectURL);
  const queryParams = useQueryParams();
  const { error: auth0Error } = useAuth0();
  const authContext = getAuthContext();
  const isParentStorage = useIsParentStorage();

  React.useEffect(() => {
    const org = `/${authContext?.organization}`;

    if (auth0Error !== undefined) {
      const isParent = isParentStorage.getValue();
      isParentStorage.clearValue();
      if (isParent === false) {
        navigate(logout(`${org}/admin`));
      } else {
        navigate(logout(org ?? undefined));
      }
    }

    if (url !== null) {
      // WARNING: when url is updated the whole component re-renders
      // this could be mitigated by using ReplaySubject in RXJS, however, rxjs adds a lot of bytes to our bundle.
      navigate(url);
    }
  }, [navigate, url, auth0Error, authContext, isParentStorage]);

  if (queryParams["error"]) {
    console.error(`${queryParams["error_description"]}`);
    return <AccessDenied></AccessDenied>;
  }

  // It's possible for the user to get stuck here at the "/auth" endpoint if the redirect in Auth0ProviderWithHistory never happens
  //   or someone navigates directly to it.
  return <Loading></Loading>;
}
